import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { ShipSetting } from '~/models/administration/shipSetting';
import { ApiServiceBase, API_NAMES } from '../api';

@Injectable({ providedIn: 'root' })
export class ShipSettingsService extends ApiServiceBase {
    constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.adminStock);
    }

    getShipSetting() {
        return this.http.get<ShipSetting>(this._url());
    }

    updateShipSettings(model: any) {
        return this.client.put(this._url(), model);
    }

    private _url(v?: string | undefined) {
        v = v || '';
        return this.url(`/ShipSettings${v}`);
    }
}
